<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg783"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs787"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath817"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path815" /></clipPath></defs><g
     id="g789"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g791"
       transform="translate(288,146.8389)"><path
         d="M 0,0 H 88"
         style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path793" /></g><g
       id="g795"
       transform="translate(288,264.0498)"><path
         d="M 0,0 H 88"
         style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path797" /></g><g
       id="g799"
       transform="translate(136,272.0332)"><path
         d="M 0,0 16,-31.934 56,15.967"
         style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path801" /></g><g
       id="g803"
       transform="translate(136,176.0996)"><path
         d="M 0,0 40,-56"
         style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path805" /></g><g
       id="g807"
       transform="translate(176,176.0996)"><path
         d="M 0,0 -40,-56"
         style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path809" /></g><g
       id="g811"><g
         id="g813"
         clip-path="url(#clipPath817)"><g
           id="g819"
           transform="translate(384,447.8599)"><path
             d="m 0,0 c 31.27,-2.05 56,-28.06 56,-59.86 v -313 c 0,-33.14 -26.86,-60 -60,-60 h -248 c -33.14,0 -60,26.86 -60,60 v 313 c 0,31.8 24.73,57.81 56,59.86"
             style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path821" /></g><g
           id="g823"
           transform="translate(158,400)"><path
             d="m 0,0 h 196 c 16.568,0 30,13.432 30,30 v 37 c 0,16.568 -13.432,30 -30,30 H 0 C -16.568,97 -30,83.568 -30,67 V 30 C -30,13.432 -16.568,0 0,0 Z"
             style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path825" /></g></g></g></g></svg>
</template>
